export function formatPrice(usd, currency, rates, symbols) {
  if (usd == null || isNaN(usd)) return null;
  const rate = rates?.[currency] || 1;
  const symbol = symbols?.[currency] ?? "$";
  const value = usd * rate;
  const decimals = currency === "JPY" ? 0 : 2;
  return `${symbol}${value.toFixed(decimals)}`;
}
